import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useI18n } from "@/i18n";
import { NotebookPen } from "lucide-react";

export default function NotesPanel({ lessonId }) {
  const { t } = useI18n();
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
    api.get(`/notes/${lessonId}`).then((r) => { setText(r.data.text || ""); setLoaded(true); }).catch(() => setLoaded(true));
  }, [lessonId]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/notes/${lessonId}`, { text });
      toast.success(t("notes.saved"));
    } catch {
      toast.error("Error");
    } finally { setSaving(false); }
  };

  return (
    <div className="mt-10 bg-graphite border border-ink/5 p-6" data-testid="notes-panel">
      <div className="flex items-center gap-2 mb-4 text-ink-soft">
        <NotebookPen size={18} strokeWidth={1.5} className="text-gold" />
        <span className="text-sm tracking-widest uppercase">{t("notes.heading")}</span>
      </div>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={t("notes.placeholder")}
        rows={4}
        data-testid="notes-textarea"
        className="w-full bg-surface border border-ink/10 px-4 py-3 text-ink placeholder:text-ink-muted focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors resize-y"
      />
      <div className="mt-3 flex justify-end">
        <button onClick={save} disabled={saving || !loaded} data-testid="notes-save"
          className="border border-ink/20 text-ink px-5 py-2 text-sm hover:border-gold hover:text-gold transition-colors disabled:opacity-50">
          {saving ? t("common.loading") : t("notes.save")}
        </button>
      </div>
    </div>
  );
}
